import CareerCounsellors from "../CareerCounsellors";

const CareerProfilesGrid = () => {
  return (
    <div className="p-5 bg-dark">
      <CareerCounsellors />
    </div>
  );
};

export default CareerProfilesGrid;
